import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      position="top-right"
      richColors
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success:
            "!bg-emerald-50 !text-emerald-900 !border-emerald-300 dark:!bg-emerald-950 dark:!text-emerald-100 dark:!border-emerald-800 [&_[data-icon]]:!text-emerald-600 dark:[&_[data-icon]]:!text-emerald-400",
          error:
            "!bg-red-50 !text-red-900 !border-red-300 dark:!bg-red-950 dark:!text-red-100 dark:!border-red-800 [&_[data-icon]]:!text-red-600 dark:[&_[data-icon]]:!text-red-400",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
